import { useEffect, useState, useContext} from 'react';
import { useNavigate } from 'react-router-dom';
import IFrame from 'react-iframe';

import MenuContext from '../store/MenuContext';
import CartClasses from '../components/Cart/Cart.module.css';

import { getLabConfig } from '../utils/api';

const CCiFrame = () => {
	const [content,setContent] = useState('');
	const [loadingIframe, setLoadingIframe] = useState(true);
	const [showiFrame,setShowiFrame] = useState(true);
	const [rCCID,setRCCID] = useState('');
	const [rStatus,setRStatus] = useState('');
	const [iFrameURL,setIFRameURL]=useState('');
	//const IFrameURL = 'https://www-stg.personapay.com/avera/webtoken/'
	const callingURL=window.location.href;
	const URLArray=callingURL.split('/');
	const revSpringToken=URLArray[URLArray.length-1];
	console.log(URLArray);
	console.log(revSpringToken);
	console.log(iFrameURL);
	useEffect(() => {
		async function fetchURL() {
			const CCC = await getLabConfig('DTCCCCREDENTIALS');
			const CCCobj = typeof CCC === 'string' ? JSON.parse(CCC) : CCC;
			setIFRameURL(CCCobj.IFRAMEURL);
		}
		fetchURL();
	}, []);

	useEffect(() => {
		if (iFrameURL) {
			const fetchedContent = iFrameURL + revSpringToken;
			setContent(fetchedContent);
		}
	}, [iFrameURL]); 

	
	useEffect(() => {
		let rdata2={};
		let rdata='';
		let rdatastatus='';
		const messageHandler = (ev:MessageEvent<{ type: string, message: string}>) => {
			console.log('ev',ev);
			  if (ev.type !== 'message') return;
			  if (!ev.data) return;
			  try {
				rdata2=JSON.parse(ev.data);
			  } catch (e) {
				  return;
			  }
			if (!rdata2.Data) return;
			  console.log(rdata2.Data);
			rdata=rdata2.Data.Transaction[0].TransactionId;
			rdatastatus=rdata2.Data.Transaction[0].TransactionStatus;
			  setRStatus(rdatastatus);
			  setRCCID(rdata);
			  setShowiFrame(false);
			}

			window.addEventListener('message', messageHandler)

			return () => window.removeEventListener('message', messageHandler)
		  }, []);
    const navigate = useNavigate();
	useEffect(() =>{
		if(!showiFrame) {
			console.log(rCCID);
			console.log(rStatus);
			sessionStorage.setItem('ccID',rCCID);
			if(rCCID =='' || typeof rCCID =='undefined' || rStatus === 'Declined')
				navigate('../CreditCardFailed');
			else{
				navigate('../OrderSuccessful?session_id='+rCCID);
			}
		}
	},[showiFrame,navigate,rCCID]);
	const menuTheme = useContext(MenuContext);

	return (
	<>
	 {showiFrame &&
			<div className={CartClasses.testInfo}>
				<h4>{showiFrame} {rCCID}</h4>
				 <IFrame
					title="Credit Card iFrame"
					width="100%" 
					height="1300"
					src={content}
					onLoad={()=>setLoadingIframe(false)}
				 >
				 </IFrame>
				 {loadingIframe ? <p> Loading ...</p> : null}

			</div>}

	</>
	);
};

export default CCiFrame;


